// import { Moment } from 'moment';

const flights: {
    [id: number]: {
        number: string,
        departureMoment: string,
        departureZuluMoment: string,
        departureZuluMoment_str: string,
        departureAirport: string,
        arrivalMoment: string,
        arrivalZuluMoment: string,
        arrivalZuluMoment_str: string,
        arrivalAirport: string
    }
} = {};

const places: {
    [id: string]: {
        name: string
    }
} = {};

const transports: {
    [id: number]: {
        name: string
    }
} = {};

export function getFlightInfo(flightID: number) {
    const flight = flights[flightID];
    if (!flight) throw new Error(`Unknown flight ID: ${flightID}`);
    return flight;
}

export function storeFlight(flightID: number, flight): void {
    flights[flightID] = flight;
}

export function getPlaceInfo(placeID: string) {
    const place = places[placeID];
    if (!place) throw new Error(`Unknown place ID: ${placeID}`);
    return place;
}

export function storePlace(placeID: string, place: { name: string }): void {
    places[placeID] = place;
}

export function getTransportInfo(transportID: number) {
    const transport = transports[transportID];
    if (!transport) throw new Error(`Unknown transport ID: ${transportID}`);
    return transport;
}

export function storeTransport(transportID: number, transport: { name: string }): void {
    transports[transportID] = transport;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/quote-data.ts